import { TFunction } from "i18next";
import { ECONTRACT_STATUS } from "../../../../enums";

export interface IFilterOption {
  id: string;
  name: string;
}

export interface IDateRange {
  from: Date | null;
  to: Date | null;
}

export interface IContractsFilters {
  status: string;
  dateRange: IDateRange;
  referenceId: string;
  sort: string;
}

export const DEFAULT_SORT = "updatedAt,desc";

export const EMPTY_FILTERS: IContractsFilters = {
  status: "",
  dateRange: { from: null, to: null },
  referenceId: "",
  sort: DEFAULT_SORT,
};

/** Whether anything narrows the list (sorting doesn't). */
export const hasNarrowingFilters = (filters: IContractsFilters) =>
  !!filters.status || !!filters.dateRange.from || !!filters.referenceId.trim();

/**
 * Statuses a project can be filtered by on each tab. The finished tab only ever holds
 * COMPLETED projects, so it has nothing to filter by.
 */
export const GET_STATUS_OPTIONS = (
  t: TFunction<"translation", undefined>,
  tabType: string
): IFilterOption[] =>
  tabType === "active"
    ? [
        { id: ECONTRACT_STATUS.DRAFT, name: t("lbl_draft") },
        {
          id: ECONTRACT_STATUS.CREATED,
          name: t("global_status_payment_title"),
        },
        { id: ECONTRACT_STATUS.IN_PROGRESS, name: t("lbl_in_progress") },
      ]
    : [];

export const GET_SORT_OPTIONS = (
  t: TFunction<"translation", undefined>
): IFilterOption[] => [
  { id: "updatedAt,desc", name: t("lbl_contracts_sort_updated_desc") },
  { id: "updatedAt,asc", name: t("lbl_contracts_sort_updated_asc") },
  { id: "createdAt,desc", name: t("lbl_contracts_sort_created_desc") },
  { id: "createdAt,asc", name: t("lbl_contracts_sort_created_asc") },
];
